export default __webpack_public_path__ + "static/media/home-data-vector.edacae3c.svg";